<template>
    <div class="ContentBox">
        <div class="commonBox TopsBlack"> <Tops :ishome="false"/></div>
        <el-carousel class="bannerBox"  trigger="click" indicator-position="outside" >
            <el-carousel-item v-for="item in 1" :key="item">
             <img src="@/assets/banner-2.png" />
            </el-carousel-item>
        </el-carousel>
        <!--  -->
        <div class="ConetBox" style="display:inline-flex!important;">
            <!-- 左边内容 -->
            <div class="LeftInfoBox" v-if="Info">
               <div class="InfoTitle">{{Info['Title']}}</div>
               <div class="InfoType">
                 <div class="type"><span>发布时间：</span>{{Info['ShowTime']}}</div>
                 <div class="type"><span>访问量：</span>{{Info['Press']}}</div>
               </div>
               <div style="height: 1px;background: #DCDCDC;"></div>
               <div class="infoCont"  v-html="Info['Details']" style="text-align:initial!important;" ></div>
            </div>
            <!-- 右边推荐内容 -->
            <div class="RightInfoBox">
                <div style="text-align:left;font-size:20px;color:rgba(51, 51, 51, 1);">最新信息</div>
                <div style="text-align:left;margin-top:15px;" v-if="activities.length">
                    <!-- <el-timeline>
                      <el-timeline-item
                        class="TuiClass"
                        v-for="(act, i) in activities"
                        :key="i"
                        :timestamp="act['ShowTime']">
                       <div @click.native="LookInfo(v.ID)"> {{act['Title']}}</div>
                      </el-timeline-item>
                    </el-timeline> -->
                    <el-steps direction="vertical" >
                        <el-step @click.native="LookInfo(act.ID)" :title="act['Title']"  space="30px" icon="el-icon-star-on" :description="act['ShowTime']" v-for="(act, i) in activities"  :key="i" class="TuiClass"></el-step>
                      </el-steps>
                </div>
                <div v-else style="margin-top:20px;color:#ccc;">暂无更多</div>
            </div>
        </div>
        <Footer />
    </div>
</template>
<script>
import Tops from "@/components/PubBox/hearTop.vue";
import Footer from "@/components/PubBox/footer.vue";
import {GetNewsInfoByNid,GetNewsInfoByCid} from '@/requestPub/api';
import merge from 'webpack-merge';
export default {
    components:{
        Tops,Footer
    },
    data() {
      return {
        currentPage1: 5,
        MenuAct:'',
        CurrInt:'',
        activities: [],
        Info:new Object()
      }
    },
    mounted(){
      this.GetInfo();
    },
    methods:{   
      GetInfo(){
        GetNewsInfoByNid({Nid:this.$route.query.ids}).then((e)=>{
          e.Data['ShowTime']=  e.Data['ShowTime'].substr(0,10);
          this.Info= e.Data;
          // 新闻资讯的列表数据 获取前10条
            GetNewsInfoByCid({ Cid: e.Data.Fid ,PageIndex:1,PageSize:10}).then((res) => {
              (res.Data.row).map((e,i)=>{
                e['ShowTime'] =  e['ShowTime'].substr(0,10);
              });
               this.activities =  (res.Data.row).filter((e)=>{
                 return e.ID!=this.$route.query.ids
               })
            });
        })
      },
      LookInfo(n){
        if(n == this.$route.query.ids){return  this.GetInfo();}
         this.$router.replace({
              query: merge(this.$route.query, {
                  'ids': n,
              })
          });
          this.GetInfo();
      },
      LookNavList(n){
        this.CurrInt = n;
      },
      ChangeNavMenu(n){
        this.MenuAct= n;
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      }
    }
}
</script>
<style lang="scss">
.el-timeline{
  padding: 0;
}
  .bannerBox {
    height: 400px;
    .el-carousel__container {
      height: 100%;
    }
    .el-carousel__indicators--outside {
      position: absolute;
      bottom: 100px;
    }
    .el-carousel__item {
      img,
      .el-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  // ConetBox
  .ConetBox{
    display: inline-flex;
    width: 1260px;
    margin: 60px auto 0;
    .LeftInfoBox{
      padding: 15px ;
      width:70%;
      margin-right: 2%;
      box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.1);  
      .InfoTitle{
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }
      .InfoType{
        display: inline-flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        margin: 10px 0 15px 0;
        .type{
          // flex: 1;
          margin: 0 10px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
        }
      }
      .infoCont{
        padding:  10px 0;
        // text-align: left;
        width: 100%;
        text-indent: initial!important;
        overflow: hidden;
        div{
          width: 100%!important;
        }
        img{
           max-width: 100%!important;
           width: auto!important;
        }
      }
    }
    .RightInfoBox{
       padding: 15px ;
        width: 28%;
        box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.1);
        .TuiClass{
          width: 100%;
          .el-step__icon-inner[class*=el-icon]:not(.is-status){
            font-size: 20px;
          }
          .el-step__title{
            font-size: 14px;
          }
          .el-step__title.is-wait{
            color:#333;
             &:hover{
               cursor: pointer;
               color:rgba(70, 106, 233, 1);
            }
          }
          &:hover > .el-timeline-item__wrapper>.el-timeline-item__content{
            cursor: pointer;
            color:rgba(70, 106, 233, 1);
            // border-bottom: 1px solid #ccc;
          }
        }
    }
  }
</style>